// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TechsList_wrapper__me_SN","heading":"TechsList_heading__aFag3","divider":"TechsList_divider__aD1YW","list":"TechsList_list__C0Abm"};